import React from 'react';

const logoStyle = {
  height: 60,
  display: 'block',
  margin: '0 auto',
};

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const LOGO_URL = '/themes/theme/diem/diem.png';
const IMG_ALT_TEXT = 'DIEM';
const SHARE_SITE_URL = 'https://share.shopfluence.app';
const ORGANISATION_ID = 'f3d73b90-539e-419c-8f12-25bb812b874c';
const INSTAGRAM_URL = 'https://www.instagram.com/diemscents';

const ShopfluenceTheme = {
  headerLogo: {
    src: LOGO_URL,
    alt: IMG_ALT_TEXT,
    size: 70,
  },
  darkLogo: {
    src: LOGO_URL,
    alt: IMG_ALT_TEXT,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 80,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: IMG_ALT_TEXT,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={LOGO_URL}
        alt={IMG_ALT_TEXT}
      />
      <br /><br />
      <h3>influencer gifting</h3>
      <h4>powered by shopfluence</h4>
    </div>
  ),
  shareSite: SHARE_SITE_URL,
  organisationId: ORGANISATION_ID,
  instagramLabel: 'Instagram Handle (1,000+ Followers)',
  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
  dobLabel: 'Date of birth (You must be 16+ to sign up)',
  dobRequired: true,
  skipMainHandles: true,
  skipAdditionalHandles: true,
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: LOGO_URL,
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
  primaryButtonColorStyle: {
    background: '#8068ab',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'violet',
  formTitle: () => (
    <h3 style={textAlignCentre}>Create your profile</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>welcome to {IMG_ALT_TEXT}.</p>
      <br />
      <p style={textAlignCentre50p}>
      Sign up here with your social handles<br />to work with {IMG_ALT_TEXT}<br />on their upcoming promotional campaigns.
      </p>
      <br />
      <br />
      <p style={textAlignCentre50p}>
      Once you have been selected you will be<br />sent discount codes to use in the store.
      </p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>To become part of the {IMG_ALT_TEXT} family, we have some simple guidelines to follow;</p>
      <br />
      <p style={textAlignCentre}>1. If you love it, share it and tag all relevant parties</p>
      <br />
      <p style={textAlignCentre}>2. Be authentic but get creative in your own unique style</p>
      <br />
      <p style={textAlignCentre}>3. If you’re not feeling the love,
  please provide honest and constructive feedback to be eligible for future campaigns</p>
      <br />
      <p style={textAlignCentre}>4. The more content you share,
  the more our brand will choose you for future campaigns</p>
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Thanks for signing up to the {IMG_ALT_TEXT} Shopfluence platform.
      We will review your application and get in touch with any suitable gifting campaigns for you.</p>
      <br />
      <p style={textAlignCentre}>Please head over to our instagram account (LINK BELOW) and hit the follow button.
      This is the best way to keep up to date with upcoming campaigns!!</p>
      <br />

      <br />
      <p style={textAlignCentre}>
        <a href={INSTAGRAM_URL}>
          <img
            href={INSTAGRAM_URL}
            className="logo"
            style={logoStyle}
            src={LOGO_URL}
            alt={IMG_ALT_TEXT}
          />
        </a>
        <a href={INSTAGRAM_URL}>Our Instagram page</a>
      </p>
      <br />
    </div>
  ),
  hideLastCheckbox: false,
  tagsHtmlTop: () => (
    <div>
      <div>Tags</div>
      <div className="spacer small" />
      <p style={textAlignCentre}>How would you describe your content style? (please select at least one)</p>
      <div className="spacer small" />
    </div>
  ),
  socialHandle2HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  socialHandle3HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  // tagsJson, //GIfta requested to hide the tags screen
  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
  tiktokOnFrontPage: true,
  extraCheckboxHtml: () => (
    <div style={textAlignCentre}>
    &nbsp;I am happy for {IMG_ALT_TEXT} to use my collaboration content<br /> in their promotional material.
    </div>
  ),
};

export default ShopfluenceTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/diem.js
 **/